/**
 * /frontend/src/features/analytics/components/whatif/ScenarioSliders.js
 */

import React from 'react';
import './ScenarioSliders.css';

/**
 * Scenario sliders for what-if modeling.
 * @param {{sections:any,staff:any,hours:any,onSectionsChange:Function,onStaffChange:Function,onHoursChange:Function}} props
 * @returns {JSX.Element}
 */
const ScenarioSliders = ({ sections, staff, hours, onSectionsChange, onStaffChange, onHoursChange }) => (
  <div className="analytics-scenario">
    <div className="analytics-scenario-block">
      <h4>Sections</h4>
      <div className="analytics-scenario-row">
        <label htmlFor="scenario-add-sections">Add sections: {sections.addSections}</label>
        <input
          id="scenario-add-sections"
          type="range"
          min="0"
          max="5"
          value={sections.addSections}
          onChange={(e) => onSectionsChange({ ...sections, addSections: Number(e.target.value) })}
        />
      </div>
      <div className="analytics-scenario-row">
        <label htmlFor="scenario-remove-sections">Remove sections: {sections.removeSections}</label>
        <input
          id="scenario-remove-sections"
          type="range"
          min="0"
          max="5"
          value={sections.removeSections}
          onChange={(e) => onSectionsChange({ ...sections, removeSections: Number(e.target.value) })}
        />
      </div>
    </div>

    <div className="analytics-scenario-block">
      <h4>Staff</h4>
      <div className="analytics-scenario-row">
        <label htmlFor="scenario-add-staff">Additional staff: {staff.additionalStaff}</label>
        <input
          id="scenario-add-staff"
          type="range"
          min="0"
          max="10"
          value={staff.additionalStaff}
          onChange={(e) => onStaffChange({ ...staff, additionalStaff: Number(e.target.value) })}
        />
      </div>
      <div className="analytics-scenario-row">
        <label htmlFor="scenario-reduce-staff">Reduced staff: {staff.reducedStaff}</label>
        <input
          id="scenario-reduce-staff"
          type="range"
          min="0"
          max="10"
          value={staff.reducedStaff}
          onChange={(e) => onStaffChange({ ...staff, reducedStaff: Number(e.target.value) })}
        />
      </div>
    </div>

    <div className="analytics-scenario-block">
      <h4>Operating Hours</h4>
      <div className="analytics-scenario-row">
        <label htmlFor="scenario-shift-start">Shift start by (hrs): {hours.shiftStartBy}</label>
        <input
          id="scenario-shift-start"
          type="range"
          min="-3"
          max="3"
          value={hours.shiftStartBy}
          onChange={(e) => onHoursChange({ ...hours, shiftStartBy: Number(e.target.value) })}
        />
      </div>
      <div className="analytics-scenario-row">
        <label htmlFor="scenario-shift-end">Shift end by (hrs): {hours.shiftEndBy}</label>
        <input
          id="scenario-shift-end"
          type="range"
          min="-3"
          max="3"
          value={hours.shiftEndBy}
          onChange={(e) => onHoursChange({ ...hours, shiftEndBy: Number(e.target.value) })}
        />
      </div>
    </div>
  </div>
);

export default ScenarioSliders;

